<template>
  <div class="p">
    <img src="~@/views/pt/images/empty-study.png" alt="">
    <p>检测到您当前正在使用手机访问应用， 可能有部分功能无法支持。</p>
    <button @click="jumpLink" class="p-button" >继续访问</button>
  </div>
</template>

<script>
export default {
  methods: {
    jumpLink() {
      this.$router.push({
        path: '/pt/student-analysis/StudyHome',
        query: {
          classId: this.$route.query.classId,
          gradeId: this.$route.query.gradeId,
          masterClassId: this.$route.query.masterClassId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .p {
    position: relative;
    height: 100vh;
    img {
      position: absolute;
      width: 100%;
      top: 35%;
      transform: translateY(-50%);
    }
    p {
      position: absolute;
      top: 55%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      width: 64%;
      height: 6%;
      font-size: 0.35rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(17, 31, 44, 0.6);
      line-height: 40px;
    }
    &-button {
      width: 68%;
      height: 92px;
      position: absolute;
      top: 65%;
      left: 50%;
      color: #1989FA;
      font-size: 0.4rem;
      line-height: 92px;
      transform: translate(-50%, -50%);
      border: 1px solid #1989FA;
      border-radius: 92px;
    }
  }
</style>
